import routerOptions0 from "/home/forge/konfigurator.smartdusche.com/releases/20260601111058/client/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}